export const bpcColors = {
  primaryBackground: '#f3f4f5',
  onImageBackground: '#ffffff',
  onIconsAndTextButtons: '#ffffff',
  onIconsAndTextButtonsVariant: '#ffffff',
  secondaryBackground: '#ffffff',
  selectedAndDetailBackground: '#e1e2e3',
  borderLine: '#d4d4d5',
  placeholderText: '#99c8ed',
  menuBackground: '#214099',
  currentStep: '#214099',
  onSecondaryAndDetailBackground: '#26292e',
  hoverMenuBackground: '#3b57a9',
  mainFocused: '#214099',
  highlight: '#00b4e0',
  tradingDown: '#00b4e0',
  tradingUp: '#00b4e0',
  off: '#d1d1d1',
  lower: '#8fa2da',
  footerBackground: '#214099',
  onFooterBackground: '#ffffff',
  popupWindow: '#214099',
  popupWindowTitle: '#ffffff',
  iconsOnFooterBackground: '#00b4e0',
  primaryDisabledBackground: '#c0d0db',
  secondaryDisabledBackground: '#f1f1f1',
  primaryDisabledText: '#a3b7c7',
  secondaryDisabledText: '#c7ccdb',
  scrollOnDetailBackground: '#bfcad4',
  scrollOnPrimaryBackground: '#dce3e9',
  infoBackground: '#F9F9F9',
  nextStep: '#8fa2da',
  previousStep: '#bfcedd',
  iconsOnMenuBackground: '#6c92ff',
  mainFocusedSoothing: '#c7d5ff',
  highlightSoothing: '#c2f0fb',
  pillBorder: '#419df0',
  pillBackgroundGloomy: '#92c4ff',
  pillBackgroundLight: '#d2edff',
  dividerOnPrimaryBackground: '#dee6fb',
  label: '#909db3',
  homePageBackground: '#ffffff',
  onHomePageBackground: '#26292e',
  refreshButton: '#ff8c3f',
  dashboardDivider: '#8fa2da',
  star: '#ffb215',
  up: '#10c765',
  down: '#ff3959',
  inert: '#adb4c3',
  scrollOnInfoBackground: '#eef2f7',
  actionBar: '#f3f4f5',
  onInfoBackground: '#26292e',
  onPrimaryBackground: '#26292e',
  lockedBackground: 'rgba(32, 51, 109, 0.65)',
  hoverHighlight: '#13cefc',
  variantOnInfoBackground: '#214099',
  variantOnPrimaryBackground: '#214099',
  graphBackground: '#e6ebf0',
  disabledAndHoverOnInfoBackground: '#d7dff6',
  disabledOnPrimaryBackground: '#bdc8e7',
  iconsSelectedOnMenu: '#ffffff',
  selectedBarOnMenu: '#00b4e0',
  selectedTextButtonMenu: '#00b4e0',
  newsBackground: '#fcfeff',
};
